(function () {
    'use strict';
    var controllerId = 'answerQuestions2';
    angular.module('app').controller(controllerId, ['$rootScope', "bootstrap.dialog", '$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', "common", "studenteSessionId", "$translate", "$interval", answerQuestions2]);

    function answerQuestions2($rootScope, bDialog, $scope, $uibModalInstance, datacontext, sectionMenu, common, studenteSessionId, $translate, $interval) {
        $scope.studenteSessionId = studenteSessionId;
        $scope.item = {};
        $scope.item.showButtons = false;
        $rootScope.timerVisibile = false;
        $scope.showPartecipazione = false;
        $scope.altezza = 125;
        $scope.blockH = $scope.altezza;

        $scope.resetTest = function () {
            var one = angular.element(document.querySelector('#blockOne'));
            var two = angular.element(document.querySelector('#blockTwo'));
            var three = angular.element(document.querySelector('#blockThree'));
            var four = angular.element(document.querySelector('#blockFour'));

            one.removeClass('hide');
            one.removeClass('full');
            two.removeClass('hide');
            two.removeClass('full');
            three.removeClass('hide');
            three.removeClass('full');
            four.removeClass('hide');
            four.removeClass('full');

            $scope.altezza = 125;
            $scope.blockH = $scope.altezza;
            $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
            $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
            $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
            $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
            $scope.item.showButtons = false;

            if (!$scope.$$phase)
                $scope.$apply();
        };

        //Eventi modali
        $rootScope.btnTermina_click = btnTermina_click;
        $rootScope.btnRiprova_click = btnRiprova_click;

        $scope.btnConfermaDisabled = false;
        $scope.basePath = datacontext.getUrl();
        $scope.studenteSession = {};
        $scope.timerThread = undefined;
        $scope.time = 0;
        $scope.loading = false;

        //Eventi	
        $scope.btnConferma_click = btnConferma_click;
        $scope.btnAnnulla_click = btnAnnulla_click;
        $scope.btnOne_click = btnOne_click;
        $scope.btnTwo_click = btnTwo_click;
        $scope.btnThree_click = btnThree_click;
        $scope.btnFour_click = btnFour_click;

        reset();
        getStudenteSession($scope.studenteSessionId);

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function reset() {
            $scope.question = {};
            $scope.choiceOne = {};
            $scope.choiceTwo = {};
            $scope.choiceThree = {};
            $scope.choiceFour = {};
            $scope.selectedChoice = 0;
            $scope.zoomQuestion = false;
            $scope.counter = "";
            $scope.btnConfermaDisabled = false;
        }

        //DataContext
        function getStudenteSession(id) {
            datacontext.studenteSession_get(id).then(function (data) {
                if (data == null)
                    return null;
                //if (data.performed == true)
                //    $location.path('/sessionHistoryDetail').search('SessionId', data.sessionId);

                //if (data.enabled == false)
                //    $location.path('/pgSessionDetailStud').search('SessionId', data.sessionId);

                datacontext.session_get(data.sessionId).then(function (session) {
                    data.tModeId = session.tModeId;

                    $rootScope.timerVisible = data.expires;

                    $scope.studenteSession = data;
                    if (data.expires) {
                        datacontext.session_getSecondsRemaining(data.sessionId).then(function (seconds) {
                            if (seconds != null)
                                $scope.time = seconds > 0 ? seconds : 0;
                            else
                                $scope.time = 0;

                            //Inizio timer
                            timerStart();
                            $scope.timerThread = $interval(timerStart, 1000);
                            $scope.index = data.questionIndex;
                            getQuestion();
                            return $scope.studenteSession;
                        });
                    }

                    $scope.index = data.questionIndex;
                    getQuestion();

                    return $scope.studenteSession;
                });
            });
        }

        //Timer
        function timerStart() {
            $scope.time -= 1;
            $scope.progressStyle = { "width": parseInt(($scope.time / ($scope.studenteSession.minutesToExpire * 60) * 100)) + "%" };

            if (!$scope.$$phase)
                $scope.$apply();
        }

        function timerStop() {
            if (angular.isDefined($scope.timerThread)) {
                $interval.cancel($scope.timerThread);
                $scope.timerThread = undefined;
            }
        }

        $scope.$on('$routeChangeStart', function (next, current) {
            timerStop();
        });

        function getQuestion() {
            $scope.resetTest();
            reset();

            var emptyChoice = {};
            emptyChoice.Id = 0;
            emptyChoice.text = "";
            emptyChoice.layout = 1;

            $scope.loading = true;
            var id = $scope.studenteSession.questions[$scope.index].questionId;

            if ($scope.studenteSession.tModeId == 1) {
                datacontext.question_getWithRandomChoices(id).then(function (data) {
                    //if (data == null) {
                    //    SharedState.turnOn('mdTestError');
                    //    return null;
                    //}
                    $scope.counter = ($scope.index + 1).toString() + "/" + $scope.studenteSession.questions.length.toString();

                    //Scarico l'immagine della domanda se layout > 1            
                    if (data.layout > 1) {
                        datacontext.getImage($scope.basePath + '/' + data.imgPath).then(function (image) {
                            if (image != null)
                                $scope.question.image = image.config.url;
                            else
                                $scope.question.image = $scope.basePath + '/' + data.imgPath;
                        });
                    }

                    if (data.choices.length > 0) {
                        $scope.choiceOne = data.choices[0] || emptyChoice;
                        $scope.choiceTwo = data.choices[1] || emptyChoice;
                        $scope.choiceThree = data.choices[2] || emptyChoice;
                        $scope.choiceFour = data.choices[3] || emptyChoice;

                        //Scarico le immagini se layout > 1
                        if (data.choices[0] != undefined && data.choices[0].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[0].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceOne.image = image.config.url;
                                else
                                    $scope.choiceOne.image = $scope.basePath + '/' + data.choices[0].imgPath;
                            });
                        }
                        if (data.choices[1] != undefined && data.choices[1].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[1].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceTwo.image = image.config.url;
                                else
                                    $scope.choiceTwo.image = $scope.basePath + '/' + data.choices[1].imgPath;
                            });
                        }
                        if (data.choices[2] != undefined && data.choices[2].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[2].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceThree.image = image.config.url;
                                else
                                    $scope.choiceThree.image = $scope.basePath + '/' + data.choices[2].imgPath;
                            });
                        }
                        if (data.choices[3] != undefined && data.choices[3].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[3].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceFour.image = image.config.url;
                                else
                                    $scope.choiceFour.image = $scope.basePath + '/' + data.choices[3].imgPath;
                            });
                        }
                    }

                    $scope.loading = false;
                    $scope.question = data;
                });
            }
            else {
                datacontext.question_get(id).then(function (data) {
                    //if (data == null) {
                    //    SharedState.turnOn('mdTestError');
                    //    return null;
                    //}
                    $scope.counter = ($scope.index + 1).toString() + "/" + $scope.studenteSession.questions.length.toString();

                    //Scarico l'immagine della domanda se layout > 1            
                    if (data.layout > 1) {
                        datacontext.getImage($scope.basePath + '/' + data.imgPath).then(function (image) {
                            if (image != null)
                                $scope.question.image = image.config.url;
                            else
                                $scope.question.image = $scope.basePath + '/' + data.imgPath;
                        });
                    }

                    if (data.choices.length > 0) {
                        $scope.choiceOne = data.choices[0] || emptyChoice;
                        $scope.choiceTwo = data.choices[1] || emptyChoice;
                        $scope.choiceThree = data.choices[2] || emptyChoice;
                        $scope.choiceFour = data.choices[3] || emptyChoice;

                        //Scarico le immagini se layout > 1
                        if (data.choices[0] != undefined && data.choices[0].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[0].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceOne.image = image.config.url;
                                else
                                    $scope.choiceOne.image = $scope.basePath + '/' + data.choices[0].imgPath;
                            });
                        }
                        if (data.choices[1] != undefined && data.choices[1].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[1].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceTwo.image = image.config.url;
                                else
                                    $scope.choiceTwo.image = $scope.basePath + '/' + data.choices[1].imgPath;
                            });
                        }
                        if (data.choices[2] != undefined && data.choices[2].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[2].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceThree.image = image.config.url;
                                else
                                    $scope.choiceThree.image = $scope.basePath + '/' + data.choices[2].imgPath;
                            });
                        }
                        if (data.choices[3] != undefined && data.choices[3].layout > 1) {
                            datacontext.getImage($scope.basePath + '/' + data.choices[3].imgPath).then(function (image) {
                                if (image != null)
                                    $scope.choiceFour.image = image.config.url;
                                else
                                    $scope.choiceFour.image = $scope.basePath + '/' + data.choices[3].imgPath;
                            });
                        }
                    }

                    $scope.loading = false;
                    $scope.question = data;
                });
            }
        }

        //Eventi
        function btnTermina_click() {
            var title = $translate.instant('Termina')+' Test';
            var msg = $translate.instant('TerminaTest');
            bDialog.confirmationDialog(title, msg).then(function () {
                datacontext.studenteSession_disable($scope.studenteSessionId).then(function (data) {
                    if (data != null) {
                        timerStop();
                        $uibModalInstance.dismiss('cancel');
                    }

                });
                //SharedState.turnOff('mdTerminaTest');

            });
        }

        function btnAnnulla_click() {
            $scope.resetTest();
            $scope.selectedChoice = 0;
        }

        function btnConferma_click() {
            $scope.btnConfermaDisabled = true;
            var questionToUpdate = $scope.studenteSession.questions[$scope.index];
            questionToUpdate.choiceId = $scope.selectedChoice;

            datacontext.questionStudenteSession_update(questionToUpdate).then(function (data) {
                if (data == null) {
                    $scope.btnConfermaDisabled = false;
                    return;
                } else if (data == 400) {
                    var title = $translate.instant('SessioneTerminata');
                    var msg = $translate.instant('NotaSessioneTerminata');
                    bDialog.informationDialog(title, msg, $translate.instant('Chiudi')).then(function () {
                        $scope.cancel();
                    });
                    $scope.btnConfermaDisabled = false;
                    return;
                }

                $scope.index++;
                if ($scope.index < $scope.studenteSession.questions.length)
                    getQuestion();
                else
                    $scope.showPartecipazione = true;

                $scope.btnConfermaDisabled = false;
            });
        }

        function btnRiprova_click() {
            //SharedState.turnOff('mdTestError');
            getQuestion();
        }

        function btnOne_click() {
            $scope.selectedChoice = $scope.choiceOne.Id;
            if ($scope.selectedChoice && $scope.selectedChoice > 0) {
                var one = angular.element(document.querySelector('#blockOne'));
                var two = angular.element(document.querySelector('#blockTwo'));
                var three = angular.element(document.querySelector('#blockThree'));
                var four = angular.element(document.querySelector('#blockFour'));
                two.toggleClass('hide');
                three.toggleClass('hide');
                four.toggleClass('hide');

                one.toggleClass('full');
                if (one.hasClass('full')) {
                    $scope.blockH = $scope.altezza * 2;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = true;
                } else {
                    $scope.blockH = 125;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = false;

                    if (!$scope.$$phase)
                        $scope.$apply();
                }

                if (!$scope.$$phase)
                    $scope.$apply();
            }
        }
        function btnTwo_click() {
            $scope.selectedChoice = $scope.choiceTwo.Id;
            if ($scope.selectedChoice && $scope.selectedChoice > 0) {
                var one = angular.element(document.querySelector('#blockOne'));
                var two = angular.element(document.querySelector('#blockTwo'));
                var three = angular.element(document.querySelector('#blockThree'));
                var four = angular.element(document.querySelector('#blockFour'));
                one.toggleClass('hide');
                three.toggleClass('hide');
                four.toggleClass('hide');

                two.toggleClass('full');
                if (two.hasClass('full')) {
                    $scope.blockH = $scope.altezza * 2;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = true;
                } else {
                    $scope.blockH = 125;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = false;

                    if (!$scope.$$phase)
                        $scope.$apply();
                }

                if (!$scope.$$phase)
                    $scope.$apply();
            }
        }
        function btnThree_click() {
            $scope.selectedChoice = $scope.choiceThree.Id;
            if ($scope.selectedChoice && $scope.selectedChoice > 0) {
                var one = angular.element(document.querySelector('#blockOne'));
                var two = angular.element(document.querySelector('#blockTwo'));
                var three = angular.element(document.querySelector('#blockThree'));
                var four = angular.element(document.querySelector('#blockFour'));
                one.toggleClass('hide');
                two.toggleClass('hide');
                four.toggleClass('hide');

                three.toggleClass('full');
                if (three.hasClass('full')) {
                    $scope.blockH = $scope.altezza * 2;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = true;
                } else {
                    $scope.blockH = 125;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = false;

                    if (!$scope.$$phase)
                        $scope.$apply();
                }

                if (!$scope.$$phase)
                    $scope.$apply();
            }
        }
        function btnFour_click() {
            $scope.selectedChoice = $scope.choiceFour.Id;
            if ($scope.selectedChoice && $scope.selectedChoice > 0) {
                var one = angular.element(document.querySelector('#blockOne'));
                var two = angular.element(document.querySelector('#blockTwo'));
                var three = angular.element(document.querySelector('#blockThree'));
                var four = angular.element(document.querySelector('#blockFour'));
                one.toggleClass('hide');
                two.toggleClass('hide');
                three.toggleClass('hide');

                four.toggleClass('full');
                if (four.hasClass('full')) {
                    $scope.blockH = $scope.altezza * 2;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = true;
                } else {
                    $scope.blockH = 125;
                    $scope.item.choiceFull = { "height": String($scope.blockH) + "px", "overflow": "hidden" };
                    $scope.item.choiceMid = { "height": String($scope.blockH / 2) + "px", "overflow": "hidden" };
                    $scope.item.imgFull = { "max-height": String($scope.blockH) + "px" };
                    $scope.item.imgMid = { "max-height": String($scope.blockH / 2) + "px" };
                    $scope.item.showButtons = false;

                    if (!$scope.$$phase)
                        $scope.$apply();
                }

                if (!$scope.$$phase)
                    $scope.$apply();
            }
        }

    }
})();